import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

interface SubtleButtonProps extends Omit<ButtonProps, 'style'> {
  showShimmer?: boolean;
}

export const SubtleButton: React.FC<SubtleButtonProps> = ({ showShimmer = false, children, ...props }) => {
  const { fontSize, screens } = useResponsiveSizes();
  const buttonHeight = screens.xs ? 35 : screens.sm ? 39 : 43;

  return (
    <>
      <Button
        {...props}
        style={{
          width: '100%',
          height: buttonHeight,
          backgroundColor: 'transparent',
          borderColor: '#e0e0e0',
          color: '#8c8c8c',
          fontSize: fontSize.base,
          fontWeight: 400,
          transition: 'all 0.3s ease',
          position: 'relative',
          overflow: 'hidden',
          userSelect: 'none'
        }}
      >
        <span style={{ position: 'relative', zIndex: 2 }}>{children}</span>
        {showShimmer && <div className='shimmer-effect' />}
      </Button>

      <style>{`
        .subtle-button:hover:not(:disabled) {
          border-color: #9A218C !important;
          color: #9A218C !important;
          background-color: rgba(154, 33, 140, 0.05) !important;
          box-shadow: 0 2px 8px rgba(154, 33, 140, 0.15) !important;
          transform: none !important;
        }

        .subtle-button:disabled {
          border-color: #e0e0e0 !important;
          color: #8c8c8c !important;
          background-color: transparent !important;
        }

        .shimmer-effect {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(154, 33, 140, 0.1), transparent);
          animation: subtle-shimmer 3s infinite;
          z-index: 1;
        }

        @keyframes subtle-shimmer {
          0% { left: -100%; }
          50% { left: -100%; }
          100% { left: 100%; }
        }
      `}</style>
    </>
  );
};
